/**
 * A binding that can be used to show a preloader on elements
 */
kendo.data.binders.preloader = kendo.data.Binder.extend({
    refresh: function() {
        $(this.element).toggleClass("preloader", !!(this.bindings.preloader.get()));
    }
});

kendo.data.binders.widget.preloader = kendo.data.Binder.extend({
    refresh: function() {
        if ($(this.element.element).is("[data-preloader-mode]")) {
            $(this.element.wrapper).toggleClass("preloader", !!(this.bindings.preloader.get()));
        } else if (this.element.progress) {
            this.element.progress(this.bindings.preloader.get());
        }
    }
});

export default {};
